import { Component } from '@angular/core';
import { StorageService } from '../../providers/storage.service';
import { NavController, NavParams } from 'ionic-angular';
import { SigninPage } from './signin';
import { SysconfigService } from './../../services/sysconfig.service';
import { TabsPage } from '../tabs/tabs';
import { AppConfig } from '../../app/app.config';



@Component({
    selector: 'agreemsg',
    templateUrl: 'agreemsg.html',
    providers: [SysconfigService]
})
export class AgreeMsg {
    agreement: string;
    // 提现次数
    WithDrawTime;
    // 最低提现金额
    MinWithDraw;
    // 最高提现金额
    MaxWithDraw;
    constructor(
        private storage: StorageService,
        private navCtrl: NavController,
        private navPar: NavParams,
        private sysconfig: SysconfigService
    ) {
        this.agreement = '';
        this.storage.write("User", this.navPar.get("user"));
    }

    //拒绝
    //TQQ 2017-01-19
    disagreeClick() {
        this.storage.remove("token");
        this.navCtrl.setRoot(SigninPage);
    }
    ionViewDidLoad() {
        this.sysconfig.getSysconfig().then(sc => {
            this.storage.write("sysconfig", sc);
            this.WithDrawTime = sc.WithDrawTimes;
            this.MinWithDraw = sc.MinWithDraw;
            this.MaxWithDraw = sc.MaxWithDraw;
        });
        this.loadAgreements();
    }
    /**
     * 协议与条款
     * an 2019-08-30
     */
    loadAgreements() {
        this.sysconfig.getAgreement().then(s => {
            if (s) {
                this.agreement = s;
            }
        }).catch(err => { console.log("getAgreement err") })
    }

    //同意
    //TQQ 2017-01-19
    agreeClick() {
        let users = this.navPar.get("users");
        let usersarr = [];
        if (users != null) {
            let storageusers = null;
            if (this.storage.readString("Users")) {
                const userArrStr = AppConfig.decodeBase64(this.storage.readString("Users"));
                storageusers = JSON.parse(userArrStr);
            }
            if (users.remeberpwd) {
                if (storageusers != null) {
                    let idx = storageusers.findIndex(s => s.username == users.username);
                    if (idx > -1) {
                        storageusers.splice(idx, 1);
                    }
                    storageusers.splice(0, 0, users);
                    this.storage.writeString("Users", AppConfig.encodeBase64(JSON.stringify(storageusers)));
                } else {
                    usersarr.push(users);
                    this.storage.writeString("Users", AppConfig.encodeBase64(JSON.stringify(usersarr)));
                }

            } else {
                if (storageusers == null) {
                    usersarr = [];
                    usersarr.push(users);
                    this.storage.writeString("Users", AppConfig.encodeBase64(JSON.stringify(usersarr)));
                    storageusers = usersarr;
                }
                let userIndx = storageusers.findIndex(s => s.username == users.username);
                if (userIndx > -1) {
                    storageusers.splice(userIndx, 1);
                    this.storage.writeString("Users", AppConfig.encodeBase64(JSON.stringify(storageusers)));
                }
            }
        }
        this.navCtrl.push(TabsPage);
    }

}

export class UserList {
    username: string;
    pwd: string;
    remeberpwd: boolean;
}



// WEBPACK FOOTER //
// ./src/pages/signin/agreemsg.ts